import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuditEventRequest } from '../models/audit.model';
import { BackendService } from './backend.service';

export interface ActivityItem {
  action_type: string;
  description: string;
  timestamp: number;
  agent_id?: string;
}

@Injectable({ providedIn: 'root' })
export class AuditService {
  constructor(private http: HttpClient, private backend: BackendService) {}

  trackEvent(req: AuditEventRequest): void {
    const url = this.backend.createUrl(environment.BASE_API.AUDIT_EVENT);
    this.http.post(url, req).pipe(catchError(() => of(null))).subscribe();
  }

  getActivities(limit = 10): Observable<ActivityItem[]> {
    const url = this.backend.createUrl(`${environment.BASE_API.AUDIT_ACTIVITIES}?limit=${limit}`);
    return this.http
      .get<{ success: boolean; body: { activities: ActivityItem[] } }>(url)
      .pipe(map(res => res?.body?.activities ?? []));
  }
}
